<template>
    <div class="checkout__accordion" v-if="!hide">
        <a href="#" class="checkout__accordion__title checkout__accordion__title--done" v-if="completed" @click="edit">{{ __('Ticket Holders') }}</a>
        <span class="checkout__accordion__title" v-else-if="!completed">{{ __('Ticket Holders') }}</span>

        <div class="checkout__block" v-if="!completed">
            <form class="form">
                <div class="wrapper">
                    <div class="row  row--reset">
                        <div v-for="(field, index) in fields" :key="field.id" class="col col--6 mq-tab--12">
                            <div class="col__inner">
                                <div class="checkout__box">
                                    <h2 class="checkout__box__ttl">{{ field.heading }}</h2>

                                    <div class="form__field">
                                        <label for="th_name" class="form__label">Name:</label>
                                        <input type="text" id="th_name" name="th_name" class="form__input  form__input--secondary" v-model="field.name">

                                        <div class="form__error" v-if="(typeof errors['fields.'+index+'.name'] != 'undefined')">
                                            <p v-for="(e, i) in errors['fields.'+index+'.name']" :key="'th_name' + i" v-html="e"></p>
                                        </div>
                                    </div>
                                    <div class="form__field">
                                        <label for="th_email" class="form__label">Email:</label>
                                        <input type="email" id="th_email" name="th_email" class="form__input  form__input--secondary" v-model="field.email">

                                        <div class="form__error" v-if="(typeof errors['fields.'+index+'.email'] != 'undefined')">
                                            <p v-for="(e, i) in errors['fields.'+index+'.email']" :key="'th_email' + i" v-html="e"></p>
                                        </div>
                                    </div>
                                    <div class="form__field" v-if="tenantId != 52">
                                        <label for="th_dob" class="form__label">Date of Birth:</label>
                                        <input type="text" id="th_dob" name="th_dob" class="form__input  form__input--secondary" 
                                            v-model="field.dob" v-mask="'##/##/####'" placeholder="dd/mm/yyyy">

                                        <div class="form__error" v-if="(typeof errors['fields.'+index+'.dob'] != 'undefined')">
                                            <p v-for="(e, i) in errors['fields.'+index+'.dob']" :key="'th_dob' + i" v-html="e"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn--tertiary" @click.prevent="save" v-if="tenantId != 63">{{ __('Next') }}</button>
                <button type="button" class="btn btn--tertiary w-full" @click.prevent="save" v-else>{{ __('Next Step: Billing Details') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tenantId: {
                type: Number,
                required: true
            },
            completed: {
                type: Boolean,
                required: true
            },
            method: {
                type: String,
                required: true
            },
            ticket: {
                type: String,
                required: true
            }
        },

        data: () => ({
            hide: false,
            fields: [],
            errors: {}
        }),

        mounted() {
            this.$emit('loading', true);

            axios.get(`/checkout/ticketholders?method=${this.method}&ticket=${this.ticket}`).then(response => {
                this.hide = true;

                if(response.data.length <= 0) {
                    this.$emit('update', {});
                    this.$emit('next');
                } else {
                    this.fields = response.data;
                    this.hide = false;
                    this.$emit('loading', false);
                }
            });
        },

        methods: {
            save() {
                
                this.$emit('loading', true);
                this.errors = {};

                axios.post('/checkout/ticketholders', {
                    method: this.method,
                    ticket: this.ticket,
                    fields: this.fields
                }).then(response => {
                    this.loading = false;
                    this.$emit('update', this.fields);
                    this.$emit('next');
                }).catch(error => {
                    this.$emit('loading', false);
                    this.errors = error.response.data.errors;
                });
            },

            edit() {

                this.$emit('edit', true);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/TicketHolders.vue